module.exports = __webpack_public_path__ + "img/labMedia2.c1865018.svg";